import React from 'react';
import styled from 'styled-components';
import { Cancel } from '@material-ui/icons';

const ImageDeleteButton = styled.button`
  background: transparent;
  border: 0;
  padding: 0;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;

  &:hover {
    background: transparent !important;
    color: transparent;
  }

  &:focus {
    outline: 0;
  }
`;

const CustomCancel = styled(Cancel)`
  &&& {
    fill: #ccc;
    width: ${props => (Boolean(props.bigger) ? '2rem' : '1rem')};
    height: ${props => (Boolean(props.bigger) ? '2rem' : '1rem')};
    &:hover {
      fill: red;
    }
  }
`;

const ClearImage = props => (
  <ImageDeleteButton {...props}>
    <CustomCancel bigger={props.biggerImage} />
  </ImageDeleteButton>
);

export default ClearImage;
